import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import { Loader2 } from 'lucide-react';

export const MapLocation = () => {
  const { data: address, isLoading: addressLoading } = useQuery({
    queryKey: ['primary-address'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('company_addresses')
        .select('*')
        .eq('is_primary', true)
        .maybeSingle();

      if (error) {
        throw error;
      }

      return data;
    },
  });

  const { data: embedData, isLoading: embedLoading } = useQuery({
    queryKey: ['maps-embed-url', address?.latitude, address?.longitude],
    queryFn: async () => {
      if (!address?.latitude || !address?.longitude) return null;
      
      const { data, error } = await supabase.functions.invoke('get-maps-embed-url', {
        body: {
          latitude: address.latitude,
          longitude: address.longitude,
          zoom: 15
        }
      });

      if (error) {
        throw error;
      }

      return data;
    },
    enabled: !!address?.latitude && !!address?.longitude,
  });

  const isLoading = addressLoading || embedLoading;

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-[200px]">
        <Loader2 className="w-8 h-8 animate-spin" />
      </div>
    );
  }

  if (!address?.latitude || !address?.longitude) {
    return (
      <div className="flex justify-center items-center h-[200px] bg-gray-100 text-gray-500">
        No location coordinates available
      </div>
    );
  }

  if (!embedData?.embedUrl) {
    return (
      <div className="flex justify-center items-center h-[200px] bg-gray-100 text-gray-500">
        Unable to load map
      </div>
    );
  }

  return (
    <div className="w-full h-[200px] rounded-lg overflow-hidden">
      <iframe
        src={embedData.embedUrl}
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
};